import PropTypes from 'prop-types';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
          bgcolor: '#000', // drawer black background
          color: '#fff', // default white text
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column',
            bgcolor: '#000',
            color: '#fff'
          },
          '& .simplebar-wrapper': {
            bgcolor: '#000',
            color: '#fff'
          },
          '& .simplebar-scroll-content': {
            bgcolor: '#000',
            color: '#fff'
          }
        }}
    >
      <Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
